import React, { cloneElement, FC, ReactElement, ReactNode } from 'react';
import Box, { BoxProps } from '@mui/material/Box';

import { EmptyDocumentIcon } from 'src/shared/components/icons';
import './EmptyState.styles.scss';

type SizeType = 'small' | 'medium' | 'large';

interface Props {
  title?: string;
  message?: ReactNode;
  icon?: ReactElement;
  className?: string;
  sx?: BoxProps['sx'];
  size?: SizeType;
}

export const EmptyState: FC<Props> = ({ message, title, icon, className = '', sx, size = 'large' }) => {
  const defaultIconSize = getDefaultIconSize(size);
  const defaultTitleSize = size === 'large' ? 'h5' : 'h6';
  const defaultTextMargin = size === 'large' ? 'mt-4' : 'mt-3';

  return (
    <Box className={`empty-state ${className}`} sx={sx}>
      {icon ? cloneElement(icon, { size: defaultIconSize }) : <EmptyDocumentIcon size={defaultIconSize} />}
      <div className="text-center">
        {title && <p className={`${defaultTitleSize} ${defaultTextMargin} fw-medium`}>{title}</p>}
        {message && <p className="mt-2 mb-0 small text-muted">{message}</p>}
      </div>
    </Box>
  );
};

const getDefaultIconSize = (size: SizeType): number => {
  switch (size) {
    case 'small':
      return 80;
    case 'medium':
      return 100;
    case 'large':
    default:
      return 150;
  }
};
